//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === API ===
import { moduleAdd } from 'api/prokey/prokey.websocket';
// === STYLES ===
import { makeStyles } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
} from '@mui/material';


//#endregion

function AddModuleDialog(props) {
  //#region [VALUES]
  const [moduleName, setModuleName] = useState('');

  const [showAlert, setShowAlert] = useState(false);
  const [alertErrText, setAlertErrText] = useState('');

  //#endregion

  //#region [EFFECT]

  useEffect(() => {}, [props.showDialog]);

  //#endregion

  //#region [MODIFY]

  function addModule() {
    let errorText = '';
    if (!moduleName) errorText += ', Module Name must be filled';

    if (errorText) {
      setAlertErrText(errorText.substring(2));
      setShowAlert(true);
      return false;
    } else {
      moduleAdd(moduleName)
           
      return true;
    }
  }

  const handleSubmitAddModuleAndClose = (e) => {
    if (addModule()) handleClose();
    setModuleName('');
  };

  const handleClose = () => {
    props.setShowDialog(false);
    handleDismissAlert();
    setModuleName('');
  };

  const handleDismissAlert = () => {
    setShowAlert(false);
    setAlertErrText('');
  };

  //#endregion

  //#region [DISPLAY]

  // ------------------------------------------------------
  // ALERT
  function Alert(props) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }
  const handleErrClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };
  const displayError = () => {
    return (
      <Snackbar open={showAlert} autoHideDuration={6000} onClose={handleErrClose}>
        <Alert onClose={handleErrClose} severity='error'>
          {alertErrText}
        </Alert>
      </Snackbar>
    );
  };

  // ------------------------------------------------------
  // MODAL

  function displayAddModuleModal() {
    return props.showDialog ? (
      <div>
        <Dialog open={props.showDialog} onClose={handleClose} aria-labelledby='form-dialog-title'>
          <DialogTitle id='form-dialog-title'>Add Module</DialogTitle>
          <DialogContent>
            <DialogContentText>Specify a new module name below</DialogContentText>
            <TextField
              autoFocus
              margin='dense'
              id='name'
              label='Module Name'
              type='text'
              fullWidth
              value={moduleName}
              autoComplete='off'
              onChange={(e) => {
                setModuleName(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary'>
              Cancel
            </Button>
            <Button onClick={handleSubmitAddModuleAndClose} color='primary'>
              Add & Close
            </Button>
          </DialogActions>
        </Dialog>
        {displayError()}
      </div>
    ) : null;
  }

  //#endregion

  return displayAddModuleModal();
}

export { AddModuleDialog };
